import { render, staticRenderFns } from "./AddMenu.vue?vue&type=template&id=41a20db6&scoped=true&"
import script from "./AddMenu.vue?vue&type=script&lang=js&"
export * from "./AddMenu.vue?vue&type=script&lang=js&"
import style0 from "./AddMenu.vue?vue&type=style&index=0&id=41a20db6&scoped=true&lang=css&"
import style1 from "./AddMenu.vue?vue&type=style&index=1&id=41a20db6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a20db6",
  null
  
)

export default component.exports